// extracted by mini-css-extract-plugin
export default {"input":"input--F8WjrS0cWYHSqx5ZjkT_"};